import apiClient from '../../api';
import { baseAPIUrl } from '../constants';

export const getNodes = async () => {
    const { data } = await apiClient({
        url: `${baseAPIUrl}/nodes`,
    });
    return data;
};
